
<script setup lang="ts">
import Menu from '@/tiers/frontend/apps/Menu.vue';
import Offcanvas from '@/components/Offcanvas.vue';
interface Item {
    'label': string;
    'url': string;
    'sub': Item[];
}
interface Props {
    list: Item[];
    location?: string;
}
const { list, location } = withDefaults(defineProps<Props>(), {
    location: '',
});


</script>
<style scoped lang="scss"></style>
<template>
    <Offcanvas empty :scroll="false" :backdrop="false" fullScreen>
        <template #button>
            <div class="burger cnd-burger">
                <div class="lines">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </div>

            </div>
        </template>

        <Menu :list="list" :location="location" socials click></Menu>
        <div class="feet">
            <p>Powered By <a href="https://codendot.com/"></a>Codendot</p>
        </div>
    </Offcanvas>
</template>
